"use client";

/**
 * Client-side home redirect that preserves URL hash.
 * Required for password reset: when user lands at /#access_token=...&type=recovery,
 * we must redirect to /auth/reset-password before the hash is lost.
 */
import { useEffect } from "react";

import { useRouter } from "next/navigation";

export function HomeRedirect() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const hash = window.location.hash;
    const search = window.location.search;

    // Password reset callback - redirect to reset page with params preserved
    // PKCE: ?code=xxx (query param)
    // Implicit: #access_token=...&type=recovery (hash)
    const hashParams = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const searchParams = new URLSearchParams(search);
    const type = hashParams.get("type");
    const code = searchParams.get("code");

    // Password reset or invite acceptance: same set-password flow
    if (type === "recovery" || type === "invite") {
      window.location.replace(`/auth/reset-password${hash}`);
      return;
    }
    if (code) {
      window.location.replace(`/auth/reset-password?code=${code}`);
      return;
    }

    router.replace("/dashboard");
  }, [router]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600" />
    </div>
  );
}
